import Popover from "components/Popover";
import RigorousJournalTooltip from "components/Popover/RigorousJournalTooltip/RigorousJournalTooltip";
import useLabels from "hooks/useLabels";
import Tag from "../Tag";
import { VeryRigorousJournalIcon } from "design_system";

interface VeryRigorousJournalTagProps {
  isCompact?: boolean;
}

function VeryRigorousJournalTag({
  isCompact,
}: VeryRigorousJournalTagProps = {}) {
  const [pageLabels] = useLabels("tooltips.rigorous-journal");

  return (
    <Popover
      interactive
      appendToParent
      tooltipContent={
        <RigorousJournalTooltip value={10} title={pageLabels["very-tag"]} />
      }
    >
      {isCompact ? (
        <div className="p-1">
          <VeryRigorousJournalIcon size="sm" />
        </div>
      ) : (
        <Tag
          label={pageLabels["very-tag"]}
          icon={<VeryRigorousJournalIcon size="sm" />}
          data-testid="very-rigorous-journal-tag"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        />
      )}
    </Popover>
  );
}

export default VeryRigorousJournalTag;
